(function () {
  function buildGrid(sectionEl) {
    var gridLarge = sectionEl.dataset.gridLarge || '3';
    var gridSmall = sectionEl.dataset.gridSmall || '2';
    var grid = document.createElement('div');
    grid.className = 'float-grid grid--' + gridLarge;
    grid.setAttribute('data-grid', '');
    grid.setAttribute('data-grid-flex', '');
    grid.setAttribute('data-grid-large', '');
    grid.setAttribute('data-grid-medium', '');
    grid.setAttribute('data-grid-small', '');
    grid.setAttribute('data-custom-scrollbar-items', '');
    grid.style.setProperty('--grid-large-items', gridLarge);
    grid.style.setProperty('--grid-medium-items', Math.min(parseInt(gridLarge, 10) || 3, 2));
    grid.style.setProperty('--grid-small-items', gridSmall);
    return grid;
  }

  function initCollectionSplitCarousels(scope) {
    (scope || document).querySelectorAll('.collection-split__carousel-nav:not([data-carousel-init])').forEach(function (nav) {
      nav.setAttribute('data-carousel-init', '');
      var sectionEl = nav.closest('.collection-split');
      var productsEl = sectionEl.querySelector('.collection-split__products');
      var dots = Array.prototype.slice.call(nav.querySelectorAll('[data-dot]'));
      var prevBtn = nav.querySelector('[data-carousel-prev]');
      var nextBtn = nav.querySelector('[data-carousel-next]');
      var total = parseInt(sectionEl.dataset.totalPages, 10) || 1;
      var current = 0;

      function getPages() {
        return Array.prototype.slice.call(sectionEl.querySelectorAll('.collection-split__carousel-page'));
      }

      function loadPage(pageIndex) {
        var pages = getPages();
        var existing = pages.find(function (p) {
          return parseInt(p.dataset.page, 10) === pageIndex;
        });
        if (existing && existing.dataset.loaded === 'true') {
          return Promise.resolve(existing);
        }

        var handle = sectionEl.dataset.collectionHandle;
        var apiSection = sectionEl.dataset.apiSection;
        if (!handle || !apiSection) {
          return Promise.resolve(null);
        }

        var pageEl = existing;
        if (!pageEl) {
          pageEl = document.createElement('div');
          pageEl.className = 'collection-split__carousel-page';
          pageEl.dataset.page = pageIndex;
          pageEl.setAttribute('aria-hidden', 'true');
          pageEl.appendChild(buildGrid(sectionEl));
          var scrollbar = productsEl.querySelector('[data-custom-scrollbar]');
          var navEl = productsEl.querySelector('.collection-split__carousel-nav');
          productsEl.insertBefore(pageEl, scrollbar || navEl);
        }

        if (pageEl.dataset.loading === 'true') {
          return new Promise(function (resolve) {
            var check = setInterval(function () {
              if (pageEl.dataset.loaded === 'true') {
                clearInterval(check);
                resolve(pageEl);
              }
            }, 50);
          });
        }

        pageEl.dataset.loading = 'true';
        pageEl.classList.add('is-loading');

        return fetch('/collections/' + encodeURIComponent(handle) + '?page=' + (pageIndex + 1) + '&sections=' + encodeURIComponent(apiSection))
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var html = data[apiSection];
            var grid = pageEl.querySelector('.float-grid');
            if (grid && html) {
              var temp = document.createElement('div');
              temp.innerHTML = html.trim();
              var apiContent = temp.querySelector('[data-api-content]');
              if (apiContent) {
                grid.innerHTML = apiContent.innerHTML;
              }
            }
            pageEl.dataset.loaded = 'true';
            pageEl.classList.remove('is-loading');
            document.dispatchEvent(new CustomEvent('shopify:section:load', {
              bubbles: true,
              detail: { sectionId: sectionEl.dataset.sectionId }
            }));
            return pageEl;
          })
          .catch(function () {
            pageEl.classList.remove('is-loading');
            return pageEl;
          })
          .finally(function () {
            pageEl.dataset.loading = 'false';
          });
      }

      function showPage(index) {
        var pages = getPages();
        if (pages[current]) {
          pages[current].classList.remove('is-active');
          pages[current].setAttribute('aria-hidden', 'true');
        }
        dots[current] && dots[current].classList.remove('is-active');

        current = Math.max(0, Math.min(index, total - 1));

        pages = getPages();
        if (pages[current]) {
          pages[current].classList.add('is-active');
          pages[current].setAttribute('aria-hidden', 'false');
        }
        dots[current] && dots[current].classList.add('is-active');

        prevBtn.disabled = current === 0;
        nextBtn.disabled = current === total - 1;
      }

      function goTo(index) {
        var target = Math.max(0, Math.min(index, total - 1));
        if (target === 0) {
          showPage(target);
          return;
        }
        loadPage(target).then(function () { showPage(target); });
      }

      prevBtn.addEventListener('click', function () { goTo(current - 1); });
      nextBtn.addEventListener('click', function () { goTo(current + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.dot, 10)); });
      });

      showPage(0);
    });
  }

  function initDeferredCollectionSplitSections(scope) {
    var root = scope || document;
    var placeholders = root.querySelectorAll('.collection-split-deferred:not([data-defer-loaded])');
    if (!placeholders.length) return;

    function loadSection(placeholder) {
      if (placeholder.dataset.deferLoaded === 'true' || placeholder.dataset.deferLoading === 'true') return;
      placeholder.dataset.deferLoading = 'true';
      placeholder.dataset.deferLoaded = 'true';

      var sectionId = placeholder.dataset.deferSectionId;
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var html = data[sectionId];
          if (!html) return;
          var temp = document.createElement('div');
          temp.innerHTML = html.trim();
          var section = temp.querySelector('.collection-split') || temp.firstElementChild;
          if (section) {
            placeholder.replaceWith(section);
            document.dispatchEvent(new CustomEvent('shopify:section:load', {
              bubbles: true,
              detail: { sectionId: sectionId }
            }));
          }
        })
        .catch(function () {
          placeholder.dataset.deferLoading = 'false';
        });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            loadSection(entry.target);
          }
        });
      }, { rootMargin: '400px 0px' });

      placeholders.forEach(function (placeholder) {
        observer.observe(placeholder);
      });
    } else {
      placeholders.forEach(loadSection);
    }
  }

  function init(scope) {
    initCollectionSplitCarousels(scope);
    initDeferredCollectionSplitSections(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();